import { useState } from 'react';
import { CircleHelp, ExternalLink } from 'lucide-react';
import { Dialog as Primitive } from 'radix-ui';
import { ajudaDaTela } from '../../lib/ajuda';
import { FormDialog, FormDialogBody, FormDialogContent, FormDialogHeader, FormDialogTitle, FormDialogFooter } from '../ui/form-dialog';
import { ConteudoAjuda } from './artigo-ajuda';

export function AjudaContextual({ pathname, coletor = false }: { readonly pathname: string; readonly coletor?: boolean }) {
  const [aberta, setAberta] = useState(false);
  const artigo = ajudaDaTela(pathname);
  return <FormDialog open={aberta} onOpenChange={setAberta}>
    <Primitive.Trigger asChild>
      <button type="button" className={`ajuda-acionador${coletor ? ' ajuda-acionador--coletor' : ''}`} aria-label="Ajuda desta tela">
        <CircleHelp size={20} aria-hidden="true" /><span>Ajuda</span>
      </button>
    </Primitive.Trigger>
    <FormDialogContent aria-describedby={undefined} className={coletor ? 'ajuda-dialog--coletor' : undefined}>
      <FormDialogHeader><FormDialogTitle>{artigo.titulo}</FormDialogTitle></FormDialogHeader>
      <FormDialogBody tabIndex={0} role="region" aria-label="Instruções desta tela"><ConteudoAjuda artigo={artigo} /></FormDialogBody>
      <FormDialogFooter>
        <a className="ajuda-link" href={`/ajuda?topico=${artigo.id}`} target="_blank" rel="noreferrer">
          Central de ajuda <span className="sr-only">(abre em nova aba)</span><ExternalLink size={16} aria-hidden="true" />
        </a>
        <a className="ajuda-link" href="/ajuda?topico=manual" target="_blank" rel="noreferrer">
          Manual de operação <span className="sr-only">(abre em nova aba)</span><ExternalLink size={16} aria-hidden="true" />
        </a>
        <Primitive.Close className="ajuda-acionador">Voltar à tela</Primitive.Close>
      </FormDialogFooter>
    </FormDialogContent>
  </FormDialog>;
}
